import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Inbox from './Inbox';

export default function AgentInbox() {
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const agentToken = localStorage.getItem('agent_token');
    const agentUser = JSON.parse(localStorage.getItem('agent_user') || '{}');

    if (!agentToken) {
      navigate('/agent-login');
      return;
    }

    localStorage.setItem('vflow_token', agentToken);
    localStorage.setItem('vflow_user', JSON.stringify({ ...agentUser, agent_mode: true }));
    localStorage.setItem('vflow_business', JSON.stringify({ id: agentUser.business_id }));
    localStorage.setItem('agent_id', agentUser.id || JSON.parse(localStorage.getItem('agent_user') || '{}').id);

    setReady(true);
  }, [navigate]);

  useEffect(() => {
    if (!ready) return;
    const agentUser = JSON.parse(localStorage.getItem('agent_user') || '{}');
    if (agentUser.business_id !== 14 || !agentUser.id) return;
    const sendHeartbeat = () => {
      axios.post('https://vbot.co.in/api/agents/heartbeat', { agent_id: agentUser.id }).catch(() => {});
    };
    sendHeartbeat();
    const interval = setInterval(sendHeartbeat, 2 * 60 * 1000);
    return () => clearInterval(interval);
  }, [ready]);

  if (!ready) return <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100vh'}}>Loading...</div>;

  return <Inbox agentMode={true} />;
}
